module.exports = __webpack_public_path__ + "static/media/instagram.66d25d07.svg";